<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        :for="label"
        class="block text-xs text-ontick-steel-900 dark:text-gray-300"
        >{{ label }}</label
      >
      <span
        v-if="optional"
        class="text-sm text-ontick-steel-800 dark:text-gray-400"
        >{{ optional }}</span
      >
    </div>
    <div class="a relative mt-1 rounded-md shadow-sm">
      <div
        v-if="trailing"
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <span class="text-gray-400 sm:text-sm">{{ trailing }}</span>
      </div>
      <input
        @input="updateValue"
        @change="updateValue"
        @blur="$emit('blur')"
        :disabled="disabled"
        :placeholder="placeholder"
        :type="type"
        :value="value"
        :maxlength="maxLength"
        :class="[
          error ? 'ring ring-ontick-red-500' : '',
          trailing ? 'px-8 ' : 'px-2',
          bg,
          noBorder ? 'border-none' : '',
          shadow,
          disabled
            ? 'text-gray-500 ring-2 ring-ontick-steel-400'
            : 'text-ontick-carbon-900 dark:text-gray-300',
          computedSize,
        ]"
        v-mask="mask"
        class="focus:outline-none block w-full appearance-none rounded-lg py-2 transition-all duration-300 focus:ring-ontick-blue-600 sm:text-sm"
      />

      <i
        v-html="$icons.loading"
        v-if="loading"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-ontick-blue-600"
      ></i>

      <div
        v-show="error"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <!-- Heroicon name: exclamation-circle -->
        <span class="text-ontick-red-500" v-html="$icons.error"></span>
      </div>
      <div
        v-show="error"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <!-- Heroicon name: exclamation-circle -->

        <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3333 13.3333L8.66667 10.6666M4.66667 10.6666V2.66665V10.6666ZM4.66667 2.66665L2 5.33331L4.66667 2.66665ZM4.66667 2.66665L7.33333 5.33331L4.66667 2.66665ZM11.3333 5.33331V13.3333V5.33331ZM11.3333 13.3333L14 10.6666L11.3333 13.3333Z" stroke="#D4D4D4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> -->

        <!-- <span class="text-ontick-red-500" v-html="$icons.error"></span> -->
      </div>
    </div>
    <p v-show="error || customError" class="mt-1 text-xs text-ontick-red-500">
      {{ error || customError }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ontick_input",

  data() {
    return {
      type_investment: true,
    };
  },

  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: String,
    noBorder: {
      type: Boolean,
    },
    shadow: {
      type: String,
      default: "shadow-lg",
    },
    bg: {
      type: String,
      default: "dark:bg-ontick-carbon-500",
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    optional: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trailing: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      required: false,
    },
    customError: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
      validator: (val) => {
        return (
          ["url", "text", "password", "email", "search", "number"].indexOf(
            val
          ) !== -1
        );
      },
    },
    fontSize: {
      type: String,
      default: "sm",
      validator: (val) => {
        return ["xs", "sm", "md", "lg"].includes(val);
      },
    },
    loading: {
      type: Boolean,
    },
    maxLength: {
      type: Number,
    },
    mask: {
      type: [String, Array],
    },
  },

  computed: {
    computedSize() {
      const sizes = {
        xs: "text-xs",
        sm: "text-sm",
        md: "text-md",
        lg: "text-lg",
      };
      return sizes[this.fontSize];
    },
  },

  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
<style></style>
